<template>
  <v-content style="height:100vh;">
    <router-view/>
  </v-content>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>